export { Avatar } from "./Avatar";
export type { AvatarIconPosition, AvatarSize, IProps } from "./Avatar";
